'use client'
import Button from '@giphy/react-giphy-brand/src/components/button'
import { giphyBlack, giphyLightGrey, giphyRed } from '@giphy/react-giphy-brand/src/css/colors'
import React, { useState } from 'react'
// import { useLocation } from 'react-router'
import Checkbox from 'shared/components/checkbox'
import { Textarea } from 'shared/components/settings/sc'
import { REASONS_DESCRIPTION, REASONS_ORDER } from 'shared/reasons'
import styled from 'styled-components'
import { Radio, SelectList } from 'ui'
import Default from 'ui/src/components/controls/dropdown-button/index'

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`

const ModalContent = styled.div`
    position: relative;
    width: 520px;
    background-color: ${giphyBlack};
    padding: 40px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.4);
`

const ModalTitle = styled.h2`
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 30px;
`

const DropdownCasing = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    position: relative;
`

const Section = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 20px;
`

const Heading = styled.h3`
    color: ${giphyLightGrey};
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
    text-align: left;
`

const StyledDefault = styled(Default)`
    width: 100%;
    max-width: 100%;
`

const AdditionalInfoInput = styled(Textarea)`
    width: 100%;
    height: 68px;
    padding: 10px 0;
    font-size: 14px;
    border: none;
    background-color: transparent;
    color: white;
    &::placeholder {
        color: ${giphyLightGrey};
    }
`

const StyledCheckboxContainer = styled.div`
    display: flex;
    align-items: center;

    width: 100%;
    margin-bottom: 20px;

    p {
        padding-right: 10px;
    }
`

const StyledRadio = styled(Radio)`
    min-width: 22px;
    margin-bottom: 0;
    padding: 0;
    margin-right: 8px;
`

const StyledCheckbox = styled(Checkbox)`
    margin-right: 10px;
    min-width: 22px;
`

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    margin-top: auto;
`

const SubmitButton = styled(Button)`
    background-color: ${giphyRed};
    display: flex;
    width: 100%;
    padding: 12px;
    font-size: 16px;
    font-weight: bold;
    justify-content: center;
    align-items: center;
`

const CancelButton = styled(Button)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.1);
    padding: 12px;
    font-size: 16px;
`

const StyledSelectList = styled(SelectList)`
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 410px;
    li {
        padding: 5px 0px 5px 10px;
        margin-right: 5px;
        width: 100%;
        &:hover {
            background-color: rgba(255, 255, 255, 0.1);
        }
    }
`

const DeactivateChannel: React.FC<{
    userToDeactivate: string
    message: string
    onDeactivate: Function
    onCancel: () => void
    onConfirm: () => void
}> = ({ onDeactivate = () => {}, message, onCancel, userToDeactivate }) => {
    const [reason, setReason] = useState<string | undefined>(undefined)
    const [label, setLabel] = useState<string | undefined>(undefined)
    const [shouldEmailUser, setShouldEmailUser] = useState(false)
    const [reporter, setReporter] = useState<undefined | 'GIPHY Proactive' | 'User Reported'>(undefined)
    const [additionalInfo, setAdditionalInfo] = useState('')

    const onConfirm = () => {
        onDeactivate(userToDeactivate, reason, shouldEmailUser, additionalInfo, reporter)
    }

    const handleReporterChange = (selectedReporter: 'GIPHY Proactive' | 'User Reported') => {
        setReporter(selectedReporter)
    }

    return (
        <ModalOverlay>
            <ModalContent>
                <ModalTitle>{message}</ModalTitle>

                <Section>
                    <DropdownCasing>
                        <StyledDefault label={label || 'Select a Reason'}>
                            <StyledSelectList
                                options={REASONS_ORDER.map((key) => REASONS_DESCRIPTION[key])}
                                onChange={(index) => {
                                    const reason = REASONS_ORDER[index]
                                    const selectedReasonLabel = REASONS_DESCRIPTION[reason]
                                    setReason(reason)
                                    setLabel(selectedReasonLabel)
                                }}
                            />
                        </StyledDefault>
                    </DropdownCasing>
                </Section>

                <Section>
                    <Heading>Reported by:</Heading>
                    <StyledCheckboxContainer>
                        <StyledRadio
                            isChecked={reporter === 'GIPHY Proactive'}
                            onChange={() => handleReporterChange('GIPHY Proactive')}
                            value="GIPHY Proactive"
                            title="GIPHY Proactive"
                        />
                        <p>GIPHY Proactive</p>
                        <StyledRadio
                            isChecked={reporter === 'User Reported'}
                            onChange={() => handleReporterChange('User Reported')}
                            value="User Reported"
                            title="User Reported"
                        />
                        <p>User Reported</p>
                    </StyledCheckboxContainer>
                </Section>
                <Section>
                    <Heading>Any additional information?</Heading>
                    <AdditionalInfoInput
                        initialValue={additionalInfo}
                        inputProps={{
                            as: 'textarea',
                            placeholder: 'Enter additional details...',
                            onChange: (evt) => {
                                setAdditionalInfo(evt.target.value)
                                console.log('Additional Info:', evt.target.value)
                            },
                        }}
                    />
                </Section>
                <Section>
                    <StyledCheckboxContainer>
                        <StyledCheckbox
                            isChecked={shouldEmailUser}
                            onChange={(checked: boolean) => {
                                setShouldEmailUser(checked)
                                console.log('Send Email to User:', checked)
                            }}
                        />
                        Send Email to User
                    </StyledCheckboxContainer>
                </Section>
                <ButtonContainer>
                    <SubmitButton onClick={onConfirm}>Confirm Deactivation</SubmitButton>
                    <CancelButton onClick={onCancel}>Cancel</CancelButton>
                </ButtonContainer>
            </ModalContent>
        </ModalOverlay>
    )
}

export default DeactivateChannel
